import { UserType } from '../types';

export const isInternalUser = (): boolean =>
  window.config.userType === UserType.Internal;
